export const IPFS_PROTOCOL = 'ipfs://'
export const IPFS_GATEWAY_URL = 'https://ipfs.io/ipfs/'
export const CF_IPFS_GATEWAY_URL = 'https://cf-ipfs.com/ipfs/'
